import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { DAYOFF_TYPE_DIALOG } from "../../../../store/slices/utils/dialogEnum";
import { closeDialog } from "../../../../store/slices/dialog/dialogSlice";
import { setDayoffType } from "../../../../store/slices/applicationManagement/managementSlice";
import { useFormik } from "formik";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../../store/slices/toast/toastSlice";
import { usePostDayoffTypesMutation } from "../../../../store";
import validations from "../utils/validations";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

const DayoffTypeForm = () => {
  const dispatch = useDispatch();
  const { dayoffType } = useSelector((state) => state.managementSlice);
  const { dayoffTypeDialogOpen } = useSelector((state) => state.dialogSlice);

  const [postDayoffType, { isLoading }] = usePostDayoffTypesMutation();

  const handleClose = () => {
    dispatch(setDayoffType(null));
    dispatch(closeDialog(DAYOFF_TYPE_DIALOG));
  };

  const formik = useFormik({
    initialValues: {
      id: dayoffType?.id ?? 0,
      name: dayoffType?.name ?? "",
      count: dayoffType?.count ?? 1,
    },
    validationSchema: validations,
    enableReinitialize: true,
    onSubmit: async (values, bag) => {
      try {
        postDayoffType({
          id: formik.values.id,
          name: formik.values.name,
          count: formik.values.count,
        }).then((response) => {
          if (!response.data.isSuccess) {
            dispatch(openErrorToast(response.data.message));
          } else {
            dispatch(openSuccessToast("İzin Türü Kaydedildi"));
            handleClose();
          }
        });
      } catch (error) {
        bag.setErrors({ general: error.response.data.message });
      }
    },
  });

  return (
    <Modal
      open={dayoffTypeDialogOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#fff",
          borderRadius: 3,
          boxShadow: 8,
          p: 4,
          minWidth: 320,
          width: 370,
        }}
      >
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{
            mb: 2,
            fontWeight: 700,
            color: "primary.main",
            textAlign: "center",
          }}
        >
          İzin Türü Bilgileri
        </Typography>
        <Stack spacing={2}>
          <TextField
            label="İzin Türü Adı"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
            fullWidth
            autoFocus
          />
          <TextField
            label="Yıllık Hak (Gün)"
            name="count"
            type="number"
            value={formik.values.count}
            onChange={formik.handleChange}
            error={formik.touched.count && Boolean(formik.errors.count)}
            helperText={formik.touched.count && formik.errors.count}
            fullWidth
            inputProps={{ min: 1 }}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isLoading}
            sx={{ fontWeight: 700, mt: 2 }}
          >
            Kaydet
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default DayoffTypeForm;
